let nextReadingSampleOptionsId = 0

function initReadingSampleChoices() {
    const choiceElements = document.querySelectorAll(
        '.title-detail-v2-component .hero .reading-sample-choice'
    )

    if (choiceElements.length === 0) {
        return
    }

    const closeChoice = (choiceElement, restoreTriggerFocus = false) => {
        const triggerElement = choiceElement.querySelector('.reading-sample-choice-trigger')
        const optionsElement = choiceElement.querySelector('.reading-sample-choice-options')

        if (!triggerElement || !optionsElement) {
            return
        }

        choiceElement.classList.remove('active')
        triggerElement.setAttribute('aria-expanded', 'false')
        optionsElement.hidden = true

        if (restoreTriggerFocus) {
            triggerElement.focus()
        }
    }

    const closeAllChoices = (choiceToKeepOpen = null) => {
        choiceElements.forEach((choiceElement) => {
            if (choiceElement !== choiceToKeepOpen) {
                closeChoice(choiceElement)
            }
        })
    }

    choiceElements.forEach((choiceElement) => {
        const triggerElement = choiceElement.querySelector('.reading-sample-choice-trigger')
        const optionsElement = choiceElement.querySelector('.reading-sample-choice-options')

        if (!triggerElement || !optionsElement) {
            return
        }

        const optionsId = `reading-sample-choice-options-${nextReadingSampleOptionsId++}`
        optionsElement.id = optionsId
        triggerElement.setAttribute('aria-controls', optionsId)

        triggerElement.addEventListener('click', (event) => {
            event.stopPropagation()
            const shouldOpen = optionsElement.hidden

            closeAllChoices(choiceElement)
            choiceElement.classList.toggle('active', shouldOpen)
            triggerElement.setAttribute('aria-expanded', shouldOpen.toString())
            optionsElement.hidden = !shouldOpen
        })

        optionsElement.addEventListener('click', () => closeChoice(choiceElement))

        choiceElement.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !optionsElement.hidden) {
                event.preventDefault()
                closeChoice(choiceElement, true)
            }
        })

        choiceElement.addEventListener('focusout', (event) => {
            if (!choiceElement.contains(event.relatedTarget)) {
                closeChoice(choiceElement)
            }
        })
    })

    document.addEventListener('click', (event) => {
        choiceElements.forEach((choiceElement) => {
            if (!choiceElement.contains(event.target)) {
                closeChoice(choiceElement)
            }
        })
    })
}

export default function init() {
    initReadingSampleChoices()
}
